import React, { useState, useEffect, useRef, useCallback } from 'react'

// Deps
// import compareAsc from 'date-fns/compareAsc'

// Partials
import { Table, TR, TD } from 'views/shared/partials/table'
import Loader from 'views/shared/partials/loader'
import Btn from 'views/shared/partials/btn'
import Dropdown from 'views/shared/partials/dropdown'
import Link from 'views/shared/partials/link'
import { InputForm, FormInput } from 'views/shared/partials/forms'

// Utils
import { openModal } from 'utils/modals';

// Services
import companyServices from 'services/company'

const AccountList = (props) => {
	const query = props.query;
	const plain = props.plain;

	const searchForm = useRef();

	const [data, setData] = useState(false);

	const makeSearch = useCallback(() => {
		setData(false);

		companyServices.listAccounts(query).then((payload) => {
			setData(payload);
		}).catch((error) => {
		});
	}, [query]);

	const deleteAccount = (account) => {
		openModal(
			'confirm',
			{
				message: '<strong>' + account.name + ' ' + account.surname + '</strong> isimli kullanıcıyı silmek istediğinizden emin misiniz?',
				onConfirm: () => {
					companyServices.deleteAccount(account.company_account_code).then(() => {
						makeSearch(query);
					}).catch(() => {})
				}
			}
		)
	}

	const unlinkAccount = (account) => {
		openModal(
			'confirm',
			{
				message: '<strong>' + account.name + ' ' + account.surname + '</strong> isimli kullanıcıyı gruptan kaldırmak istediğinizden emin misiniz?',
				onConfirm: () => {
					companyServices.unmatchAccountAndGroup(props.groupID, account.company_account_code).then(() => {
						makeSearch(query);
					}).catch(() => {})
				}
			}
		)
	}

	useEffect(() => {
		makeSearch();	
	}, [query, makeSearch])

	return (
		<section className={'portlet paymentlist ' + (props.className ? props.className : '')}>
			<div className="portlet-header">
				<strong className="portlet-title">{props.groupID ? 'Gruba Ait Kullanıcılar' : props.title}</strong>

				<div className="header-controls">
					{props.groupID ?
						<Btn white small wide icon="plus" onClick={() => { openModal('link-account-to-group', { groupID: props.groupID, onSuccess: makeSearch }); }}>Kullanıcı Ekle</Btn>
						:
						<Btn white small wide icon="plus" onClick={() => { openModal('account', { onSuccess: makeSearch }); }}>Kullanıcı Oluştur</Btn>
					}
				</div>
			</div>

			{!plain &&
				<InputForm
					ignoreEmpty
					className="portlet-filters"
					ref={searchForm}
					onSubmit={props.onSearch}>
					<div className="filters-searchwrap">
						<FormInput
							className="lower"
							type="text"
							name="search_value"
							value={query.search_value}
							//onChange={(val) => { setFilters({...filters, search_value: val}) }}
							placeholder="Kullanıcı Adı, Kullanıcı Kodu vs...">
						</FormInput>
						<button
							type="submit"
							className="searchwrap-submit">
							<i className="icon-search"></i> ara
						</button>
					</div>
				</InputForm>
			}
			<div className="portlet-section bottom loader-container">
				<Loader loading={!data} />

				{data &&
					<Table 
						emptyMessage="Aradığınız kriterlerde grup bulunmuyor."
						className="list-table"
						pagination={!plain ? data.pagination : undefined}
						onPaginate={(page) => { props.onPaginate(page); }}
						heading={
							<React.Fragment>
								<th>Kullanıcı Adı / Kodu</th>
								<th>E-Posta</th>
								<th>Yetki</th>
								<th>Durum</th>
								<th>Grup Sayısı</th>
								<th></th>
							</React.Fragment>
						}>
						
						{data.accounts.map((account, nth) => (
							<TR key={nth} mobileTitle={account.name + ' ' + account.surname}>
								<TD className="mobile-full">
									<p className="hide-mobile">
										<strong>{account.name} {account.surname}</strong>
									</p>
									<p className="table-subtitle">
										{account.company_account_code}
									</p>
								</TD>
								<TD className="mobile-full">
									{account.email}
								</TD>
								<TD className="mobile-full">
									{account.is_owner ?
										'Yönetici'
										:
										'Kullanıcı'
									}
									{account.is_group_report && ' + Rapor'}
									{account.is_group_clients && ' + Sadece Grup Müşterileri'}
								</TD>
								<TD className="mobile-full">
									{account.status === 1 ?
										<label className="label success">
											Aktif
										</label>
										:
										<label className="label error">
											Pasif
										</label>
									}
								</TD>
								<TD mobileTitle="Grup Sayısı">
									{account.stores_count}
								</TD>
								<TD className="controls">
									<Dropdown
										text="İşlemler"
										icon="list">
										<Link
											href="settings.accountDetail"
											params={{ id: account.company_account_code }}>
											Detaya Git
										</Link>
										<Link
											href="orders"
											params={{ query: 'company_account_code=eerferer='+account.company_account_code }}>
											Ödeme Talepleri
										</Link>
										{props.groupID ?
											<button
												className="error"
												onClick={() => { unlinkAccount(account) }}>
												Gruptan Kaldır
											</button>
											:
											<button
												className="error"
												onClick={() => { deleteAccount(account) }}>
												Kullanıcıyı Sil
											</button>
										}
									</Dropdown>
								</TD>
							</TR>
						))}
					</Table>
				}
			</div>
		</section>
	)
}

AccountList.defaultProps = {
	query: {},
	plain: false,
	initialFiltersOpen: false,
	title: 'Kullanıcılar',
	groupID: false,
	onPaginate: () => {},
	onSearch: () => {},
}


export default AccountList;